import Super from 'client-portal/routes/-request/confirmation';
import classic from 'ember-classic-decorator';

@classic
export default class WidgetConfirmation extends Super {}
